"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendErrorLog = exports.sendAuditLog = void 0;
var _stacktraceJs = _interopRequireDefault(require("stacktrace-js"));
var _CallAPI = require("../components/system/CallAPI");
var _APIs = require("../constants/APIs");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * フロントサイドのエラーログ情報をサーバーへ送信する.
 * @param {string} sessionId -セッションID
 * @param {string} type -ログの種類
 * @param {string} detail -詳細データ
 */
const sendErrorLog = (sessionId, type, error) => {
  if (!sessionId || sessionId === null) {
    return;
  }
  let err = error;
  if (!err instanceof Error) {
    try {
      err = new Error(JSON.stringify(err));
    } catch (e) {
      err = new Error(type);
    }
  }
  _stacktraceJs.default.fromError(err).then(stackframes => {
    const detail = '    at ' + stackframes.map(function (sf) {
      return "".concat(sf.fileName, "#").concat(sf.functionName, "():").concat(sf.lineNumber, ":").concat(sf.columnNumber);
    }).join('\n    at ');
    const sendData = {
      type: type,
      message: err.message,
      detail: detail
    };
    sendLog(_APIs.FRONT_LOG, sessionId, sendData);
  }).catch(err => {});
};

/**
 * フロントサイドの監査ログ情報をサーバーへ送信する.
 * @param {string} sessionId -セッションID
 * @param {string} operation -操作
 * @param {string} message -メッセージ
 */
exports.sendErrorLog = sendErrorLog;
const sendAuditLog = (sessionId, operation, message) => {
  if (!sessionId || sessionId === null) {
    return;
  }
  const sendData = {
    operation: operation,
    message: message
  };
  sendLogOther(_APIs.AUDIT_LOG, sessionId, sendData);
};
exports.sendAuditLog = sendAuditLog;
const sendLog = (api, sessionId, sendData) => {
  const baseUrl = (0, _CallAPI.getBaseUrl)();
  const option = (0, _CallAPI.createOption)(sessionId, sendData);
  fetch(baseUrl + api, option).then(() => {}).catch(() => {});
};
const sendLogOther = (api, sessionId, sendData) => {
  const baseUrl = (0, _CallAPI.makeBaseUrl)();
  const option = (0, _CallAPI.createOption)(sessionId, sendData);
  fetch(baseUrl + api, option).then(() => {}).catch(() => {});
};